import React from "react";
import { TextField } from "@mui/material";
import { formInputSx, themedFormInputSx } from "../common/formFieldStyles";

/**
 * Tüm menülerde kullanılacak standart metin alanı.
 * palette prop'u verilirse tema rengi uygulanır.
 */
export default function FormTextField({
  palette,
  sx = {},
  size = "small",
  ...rest
}) {
  const base = palette ? themedFormInputSx(palette) : formInputSx;
  return (
    <TextField
      size={size}
      sx={{ ...base, ...sx }}
      {...rest}
    />
  );
}
